import { InteractionStepType } from '@scale/shared/types/chat';
import FieldsBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/FieldsBuilder';
import StringInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/StringInputBuilder';
import { TextCollectionField } from '@scale/shared/types/params/textcollection';
import { memo } from 'react';
import { StepConfigurationComponentProps } from '../stepDescriptor/types';
import { typeBuilderMap } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemas';

function QIRTextCollectionConfigurationComponent({
  params: currentParams,
  setParams: setCurrentParams,
  deliveryBuilderConfig,
}: StepConfigurationComponentProps<InteractionStepType.QIRTextCollection>) {
  return (
    <div>
      <div className="mb-4">
        <StringInputBuilder
          name={'Title'}
          existingValue={currentParams.title}
          updateProperty={(value: string) => setCurrentParams({ ...currentParams, title: value })}
          required={true}
        />
      </div>
      <div className="mb-4">
        <StringInputBuilder
          name={'Subtitle'}
          existingValue={currentParams.subtitle}
          updateProperty={(value: string) =>
            setCurrentParams({ ...currentParams, subtitle: value })
          }
        />
      </div>
      <div className="mb-4">
        <div className="mb-2 font-medium">Fields</div>
        <div className="mb-2 text-sm text-neutral-500">
          Add fields to collect from the user. You can add as many fields as you want.
        </div>
        <FieldsBuilder
          typeBuilderMap={typeBuilderMap}
          name={''}
          stepId={currentParams.id}
          existingValue={currentParams.params.fields}
          updateProperty={(value: TextCollectionField[]) =>
            setCurrentParams({
              ...currentParams,
              params: { ...currentParams.params, fields: value },
            })
          }
          deliveryBuilderConfig={deliveryBuilderConfig}
        />
      </div>
    </div>
  );
}
export default memo(QIRTextCollectionConfigurationComponent);
